import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage } from "../Utils/Utils";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const callGetGridData = async () => {
    try {
        let getUrl = `${BaseUrl}HealthInsurance/GetInsuranceData`
        const res = await axios.get(getUrl, JsonConfig)
        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload)
            let loopedList = [];
            loopedList.length = 0;
            sample.forEach(sampleList => {
                const templist = JSON.parse(sampleList.NewEmployeeData)
                const dataArray = Object.entries(templist).map(([date, value]) => ({ date, value }));
                const sampleData = {
                    "Id": sampleList.Id,
                    "Division": sampleList.Division,
                    "Corp_W2": sampleList.Corp_W2,
                    "SSN": sampleList.SSN,
                    "File": sampleList.File,
                    "Full_Name": sampleList.Full_Name,
                    "Freq": sampleList.Freq,
                    "Status": sampleList.Status,
                    "Employee_Status": sampleList.Employee_Status,
                    "TermDate": sampleList.TermDate,
                    "Pay_Cycle": sampleList.Pay_Cycle,
                    "Plan_Type": sampleList.Plan_Type,
                    "Plan_Admin_Name": sampleList.Plan_Admin_Name,
                    "Code": sampleList.Code,
                    "ER_Cost": sampleList.ER_Cost,
                    "Effective_Date": sampleList.Effective_Date,
                    "EE_PreTax": sampleList.EE_PreTax,
                    "EE_PostTax": sampleList.EE_PostTax,
                    "Payroll_Code": sampleList.Payroll_Code,
                    "Total_Cost": sampleList.Total_Cost,
                    "Per_Day": sampleList.Per_Day,
                    "upload_Date": sampleList.upload_Date,
                }
                loopedList.push({
                    ...sampleData,
                    NewEmployeeData: dataArray,
                });
            });
            return loopedList;
        }
        else if (res.data.statusCode === 204){
            InfoMessage(res.data.message);
            return null;
        }
        else {
            ErrorMessage(res.data.message);
            return null;
        }
    }
    catch {
        ErrorMessage("Data fetching was failed");
        return null
    }
}

export const csvDownloadHRGridData = async (props) => {
    const temp = props;
    try {
        if (temp.length > 0) {
            let sampleList = temp;
            let loopedList = [];
            loopedList.length = 0;
            let len = sampleList.length;

            // Function to sanitize cell values
            const sanitizeCell = (value) => {
                if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
                    return `'${value}`; // Prefix with an apostrophe
                }
                return value; // Return value as-is
            };

            const datesArray = sampleList[1].NewEmployeeData.map(item => sanitizeCell(item.date)); // Sanitize dates
            loopedList.push([
                "Division", "Corp W2", "SSN", "File", "Full Name", "State", "Frequency", "Client", "Status", 
                "Employee Status", "TermDate", "Pay Cycle", "Plan Type", "Plan Admin Name", "Code", "ER Cost", 
                "Effective Date", "EE Pre-Tax", "EE Post-Tax", "Payroll Code", "Total Cost", "Per Day", ...datesArray
            ]);

            for (let i = 0; i < len; i++) {
                const sanitizedArray = sampleList[i].NewEmployeeData.map(item => sanitizeCell(item.value)); // Sanitize values
                loopedList.push([
                    sanitizeCell(sampleList[i].Division),
                    sanitizeCell(sampleList[i].Corp_W2),
                    sanitizeCell(sampleList[i].SSN),
                    sanitizeCell(sampleList[i].File),
                    sanitizeCell(sampleList[i].Full_Name),
                    " ",
                    sanitizeCell(sampleList[i].Freq),
                    " ",
                    sanitizeCell(sampleList[i].Status),
                    sanitizeCell(sampleList[i].Employee_Status),
                    sanitizeCell(sampleList[i].TermDate),
                    sanitizeCell(sampleList[i].Pay_Cycle),
                    sanitizeCell(sampleList[i].Plan_Type),
                    sanitizeCell(sampleList[i].Plan_Admin_Name),
                    sanitizeCell(sampleList[i].Code),
                    sanitizeCell(sampleList[i].ER_Cost),
                    sanitizeCell(sampleList[i].Effective_Date),
                    sanitizeCell(sampleList[i].EE_PreTax),
                    sanitizeCell(sampleList[i].EE_PostTax),
                    sanitizeCell(sampleList[i].Payroll_Code),
                    sanitizeCell(sampleList[i].Total_Cost),
                    sanitizeCell(sampleList[i].Per_Day),
                    ...sanitizedArray
                ]);
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (let i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i].map(sanitizeCell)); // Sanitize entire row
            }

            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'HealthInsuranceData.csv');
                });
            return "downloaded";
        } else {
            return null;
        }
    } catch {
        ErrorMessage("Unable to download");
        return null;
    }
};

export const prepareCSV = async (props, item) => {
    try {
        const temp = props;
        if (temp.length > 0) {
            let sampleList = temp;
            let loopedList = [];
            loopedList.length = 0;
            let len = sampleList.length;
            let i;
            const sanitizeCell = (value) => {
                if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
                    return `'${value}`; // Prefix with an apostrophe
                }
                return value; // Return value as-is
            };

            loopedList.push(["Company ID", "Employee ID", "Earning or Deduction Name", "Calculation Type", "Calculation Base", "Include Memo Hours",
                `Amount / Rate (${item})`, "Frequency Schedule", "Next Date", "Pay Component Frequency", "Selection 1", "Selection 2", "Every [x] Pay Period", "Limit Amount",
                "Maximum Amount", "Annual Wage Amount", "Group Term Life Policy Amount", "Agency Name", "Agency Street", "Agency City", "Agency State",
                "Agency Zip", "Garnishment Type", "Case / Account Number", "Additional Number", "Order Start Date", "Plaintiff Name", "Recipient Name",
                "Recipient SSN", "Provides Medical Support", "Memo", "PI Percent", "PI Calculation Base", "PI Hours", "PI Fixed Amount", "PI Adjustment Amount",
                "PI Adjustment Dependents", "Minimum Wage Regulation", ""])
            for (i = 0; i < len; i++) {
                const transformedData = sampleList[i].NewEmployeeData.map(({ date, value }) => (
                    { [date]: value }
                ));
                const objectWithDate = transformedData.find(obj => Object.keys(obj)[0] === item);
                const valueForDate = objectWithDate ? Object.values(objectWithDate)[0] : null;
                loopedList.push([
                    sanitizeCell(sampleList[i].Division),
                    sanitizeCell(sampleList[i].File),
                    sanitizeCell(sampleList[i].Payroll_Code),
                    "FD",
                    "",
                    "",
                    sanitizeCell(valueForDate),
                    "",
                    "",
                    "P",
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i].map(sanitizeCell));
            }
            workbook.csv.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'text/csv;charset=utf-8' });
                    FileSaver.saveAs(blob, 'HealthInsuranceTemplate.csv');
                });

            return "downloaded"
        }
        else { return null }

    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const GetActiveListLastUploadedDate = async () => {
    try {
        let url = `${BaseUrl}HealthInsurance/getupdatedDates`;
        const Response = await axios.get(url, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        console.log(JsonResponse);
        if (JsonResponse != null) {
            if (JsonResponse.statusCode === 200) {
                return JsonResponse;
            }
            else {

                ErrorMessage(JsonResponse.message);
                return null;
            }
        }
        else {
            ErrorMessage("Unable to resolve request");
            return null;
        }

    } catch (error) {
        ErrorMessage("Unable to resolve request");
        return null;

    }

}